import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DataSource } from '@europrocurement/l2d-redux-utils';
import { Formalite } from '@europrocurement/l2d-domain/reducers/formalites/slices/formalite';
import { formalitiesSelector, useFormaliteService } from '@europrocurement/l2d-domain';
import { AppDispatch } from '../../../redux/types';

type UseFormaliteProps = {
    formalityId: string | undefined;
};

const useFormality = (props: UseFormaliteProps) => {
    const { selectFormality } = useFormaliteService();

    const { formalityId } = props;
    const formaliteDataSource: DataSource<Formalite> = useSelector(formalitiesSelector);
    const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {
        if (formalityId) {
            dispatch(selectFormality({ id: formalityId }));
        }
    }, [dispatch, formalityId, selectFormality]);

    const formality = useMemo(() => formaliteDataSource.selected, [formaliteDataSource.selected]);

    const listFormalities = () => formaliteDataSource.data;

    return { formality, requestState: formaliteDataSource.selectedStatus, listFormalities };
};

export default useFormality;
